<template>
  <div class="scrollable only-y">
    <div class="page-header">
      <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-base card-shadow--medium p-30">
      <el-row :gutter="50">
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
          <h2>Datos de registro</h2>
          <el-form
            :model="form"
            :inline="true"
            ref="form"
            status-icon
            label-width="150px"
            size="medium"
            class="demo-form"
            :rules="rules"
            :label-position="innerWidth > 1300 ? 'left' : 'top'"
            v-loading="loadingForm"
          >
            <el-form-item label="Código" prop="nit">
              <el-input
                v-model="form.nit"
                autocomplete="off"
                placeholder="Código de la bodega"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Nombre" prop="name">
              <el-input
                v-model="form.name"
                autocomplete="off"
                placeholder="Nombre de la bodega"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Responsable" prop="responsable">
              <el-input
                v-model="form.responsable"
                autocomplete="off"
                placeholder="Nombre del Responsable"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Email" prop="email">
              <el-input
                v-model="form.email"
                autocomplete="off"
                placeholder="ejemplo@email.com"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Pais" prop="country">
              <el-input
                v-model="form.country"
                autocomplete="off"
                placeholder
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Ciudad" prop="city">
              <el-input
                v-model="form.city"
                autocomplete="off"
                placeholder
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Direccion" prop="address">
              <el-input
                v-model="form.address"
                autocomplete="off"
                placeholder
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Telefono Celular" prop="cell_phone">
              <el-input
                v-model="form.cell_phone"
                autocomplete="off"
                placeholder
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Telefono Fijo" prop="phone">
              <el-input
                v-model="form.phone"
                autocomplete="off"
                placeholder
                clearable
              ></el-input>
            </el-form-item>
          </el-form>
            <div>
              <el-button
                type="primary"
                @click="submitForm('form')"
                :loading="loading"
                icon="el-icon-check"
                v-if="!edit"
                >Guardar</el-button
              >
              <el-button
                type="warning"
                @click="submitForm('form')"
                :loading="loading"
                icon="el-icon-edit"
                v-else
                >Actualizar</el-button
              >
              <el-button @click="resetForm('form')" icon="el-icon-close"
                >Cancelar</el-button
              >
            </div>
        </el-col>
        <!-- grid -->
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
          <el-table
            :data="
              tableData.filter(
                (data) =>
                  !search ||
                  data.razon_social.toLowerCase().includes(search.toLowerCase())
              )
            "
            style="width: 100%; margin-top: 20px"
            height="500"
            v-loading="loadingTable"
          >
            <el-table-column
              label="Código"
              prop="nit"
              width="80"
            ></el-table-column>
            <el-table-column
              label="Sucursal"
              prop="razon_social"
              width="110"
            ></el-table-column>
            <el-table-column
              label="Responsable"
              prop="representante"
            ></el-table-column>
            <el-table-column label="Ciudad" prop="ciudad" width="120"></el-table-column>
            <el-table-column label="Telefono" prop="telefono" width="150"></el-table-column>
            <!-- <el-table-column label="Zona" prop="zone" width="115"> -->
              <!-- <template slot-scope="scope">
                <div><i class="mdi mdi-flag-triangle"></i> {{ ((scope.row.zone) ? scope.row.zone.name : '') }}</div>
              </template>
            </el-table-column> -->
            <el-table-column align="right">
              <template slot="header">
                <el-input
                  v-model="search"
                  size="mini"
                  placeholder="Digite el nombre"
                />
              </template>
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Editar"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="warning"
                    @click="handleEdit(scope.$index, scope.row)"
                    icon="el-icon-edit"
                    circle
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Eliminar"
                  placement="top"
                >
                  <el-button
                    v-can="['admin']"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <modal-computers
      :modalOpen="modalOpen"
      :store="store"
      @close="
        modalOpen = false;
        store = '';
      "
      @refresh="getTableData"
    ></modal-computers>
  </div>
</template>

<script>
import ModalComputers from "../../../../views/pages/administration/store/ModalComputers.vue";
import { store, update, getAll, getById, deleteData } from "@/api/store";
import { getAll as getAllZones } from "@/api/zone";
export default {
  name: "Store",
  components: {
    ModalComputers,
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      loadingTable: false,
      modalOpen: false,
      edit: false,
      store: "",
      innerWidth: 0,
      labelPosition: "top",
      zones: '',
      form: {
        id: "",
        nit: "",
        name: "",
        responsable: "",
        email: "",
        country: "",
        city: "",
        address: "",
        phone: "",
        cell_phone: "",
        // zone_id: ""
      },
      rules: {
        nit: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        responsable: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        cell_phone: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
        zone_id: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: ["blur","change"],
          },
        ],
      },
      tableData: [],
      search: "",
    };
  },
  methods: {
    getZones(){
      getAllZones()
        .then(({ data }) => {
          this.zones = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    resizeOpenNav() {
      this.innerWidth = window.innerWidth;
    },
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.edit) {
            this.updateForm();
          } else {
            this.saveForm();
          }
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveForm() {
      var datas = this.setDatas();
      store(datas)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.getTableData();
            this.resetForm("form");
          } else {
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log("Err: ", error);
        });
    },
    updateForm() {
      var datas = this.setDatas();
      update(datas)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.getTableData();
            this.resetForm("form");
          } else {
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log("Err: ", error);
        });
    },
    setDatas() {
      return {
        id: this.form.id,
        nit: this.form.nit,
        razon_social: this.form.name,
        representante: this.form.responsable,
        email: this.form.email,
        pais: this.form.country,
        ciudad: this.form.city,
        direccion: this.form.address,
        telefono: this.form.phone,
        celular: this.form.cell_phone,
        celular: this.form.cell_phone,
        zone_id: parseInt(this.form.zone_id),
      };
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.loading = false;
      this.edit = false;
    },
    getTableData() {
      this.loadingTable = true;
      getAll()
        .then(({ data }) => {
          this.loadingTable = false;
          this.tableData = data;
        })
        .catch(function (error) {
          this.loadingTable = false;
          console.log(error);
        });
    },

    // table
    handleComputers(index, row) {
      this.modalOpen = true;
      this.store = row;
    },
    handleEdit(index, row) {
      let me = this;
      this.loadingForm = true;
      getById(row.id)
        .then(({ data }) => {
          this.edit = true;
          this.loadingForm = false;
          this.form = {
            id: data.id,
            nit: data.nit,
            name: data.razon_social,
            responsable: data.representante,
            email: data.email,
            country: data.pais,
            city: data.ciudad,
            address: data.direccion,
            phone: data.telefono,
            cell_phone: data.celular,
            zone_id: ((data.zone_id !== null) ? parseInt(data.zone_id) : "")
          };
        })
        .catch(function (error) {
          console.log("Err: ", error);
        });
    },
    handleDelete(index, row) {
      this.$confirm("Desea eliminar este registro?", "Atención!", {
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          deleteData(row.id)
            .then(({ data }) => {
              this.loading = false;
              if (data.code === 200) {
                this.getTableData();
                this.resetForm("form");
              } else {
                this.$message.error("Error! " + data.error.errorInfo[2]);
              }
            })
            .catch(function (error) {
              this.loading = false;
              console.log("Err: ", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Operación Cancelada",
          });
        });
    },
  },
  created() {
    this.getTableData();
    // this.getZones();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeOpenNav);
  },
};
</script>

<style lang="scss">
  .el-form-item{
    width: 100%;
  }
.el-select {
  width: 100%;
}
.el-icon-circle-check {
  color: #1cc529;
}
</style>
